import { render, staticRenderFns } from "./IpJobAllocationPage.vue?vue&type=template&id=176d9cda&scoped=true&"
import script from "./IpJobAllocationPage.vue?vue&type=script&lang=js&"
export * from "./IpJobAllocationPage.vue?vue&type=script&lang=js&"
import style0 from "./IpJobAllocationPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IpJobAllocationPage.vue?vue&type=style&index=1&id=176d9cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d9cda",
  null
  
)

export default component.exports